import { render, staticRenderFns } from "./OneService.vue?vue&type=template&id=0b0f1a7e&scoped=true&"
import script from "./OneService.vue?vue&type=script&lang=ts&"
export * from "./OneService.vue?vue&type=script&lang=ts&"
import style0 from "./OneService.vue?vue&type=style&index=0&id=0b0f1a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f1a7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
